import {useTranslation} from "react-i18next";
import {useAuth} from "../../services/use-auth";
import {NavLink, useRouteMatch} from "react-router-dom";
import {useEffect, useState} from "react";
import AdvertiseBlock from "../../components/AdvertiseBlock";
import EventFilter from "../../components/Events/Filter";

import '../../assets/styles/events/conferencesList.scss';
import '../../assets/styles/events/conferenceList/conferenceListPage.scss';
import FavoriteEventList from "../../components/Events/FavoriteList";
import useMetaTags from "react-metatags-hook";
import trackPageView from "../../services/trackPageView";

export default function FavoriteEvents() {
    const chunkSize = 16;
    const { t } = useTranslation();
    useMetaTags({
        title: t('conferences.favoriteTitle'),
        description: t('app.description'),
        metas: [
            { name: 'keywords', content: t('app.keywords') }
        ],
    });
    useEffect(() => {
        trackPageView(t('conferences.favoriteTitle'));
    })
    const auth = useAuth();
    const [filter, setFilter] = useState({});
    const notifyFilterChange = (filter) => {
        setFilter(filter)
    }

    return (
        <section>
            <div className="filter-wrap">
                <h1>{ t('conferences.header') }</h1>
                <EventFilter
                    notifyChange={notifyFilterChange}
                />
            </div>
            <div className="container">
                <div className="conference-list">
                    {
                        !!auth.user &&
                        <nav className="navigation-conference">
                            <NavLink exact activeClassName="active" to={`/conferences`}>{ t('conferences.tabs.all') }</NavLink>
                            <NavLink exact activeClassName="active" to={`/conferences/favorite`}>{ t('conferences.tabs.favorite') }</NavLink>
                        </nav>
                    }
                    <AdvertiseBlock
                        unitId="conferences1"
                        blockLocation="top1"
                    />
                    <h2 className="not-found-title hidden js-filters-failed">
                        { t('conferences.noConferences') }
                    </h2>
                    <FavoriteEventList
                        chunkSize={chunkSize}
                        filters={filter}
                    />
                </div>
            </div>
        </section>
    );
}
